module.exports = __webpack_public_path__ + "0516f67e0f60a69c42e0fadaf29c092c.MP3";